import React from 'react';
import { useSelector } from 'react-redux';

import { Text, Spacer } from '@zillow/constellation';

import { UserSelectors } from 'app/shared/selectors';
import accessUtils from 'app/shared/utils/accessUtils';
import BillingConstants from 'app/shared/constants/BillingConstants';
import CheckSampleImage from 'app/shared/images/Paybycheck@2x.png';
import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';

const { ZRN_BILLING_EMAIL, ROCKETSHIP_BILLING_EMAIL } = BillingConstants;
const { USER_TYPES } = UserPermissionsConstants;

const PaymentInfoModal = () => {
    const isRocketship = !useSelector(
        state => UserSelectors.makeUser(state).roles.some(role => role === USER_TYPES.MULTIFAMILY_CUSTOMER)
    );
    const user = useSelector(state => UserSelectors.makeUser(state));

    return (
        <Spacer marginX="sm">
            {!accessUtils.canAccessInvoicePayments({ user }) && (
                <React.Fragment>
                    <Spacer marginBottom="xs">
                        <Text fontType="h5" as="div">Pay by Credit Card</Text>
                    </Spacer>
                    <Text as="div"> Please contact Zillow Group Rentals.</Text>
                    <Text>
                        Tel: 206-757-5194, Email:&nbsp;
                        <a href={`mailto:${isRocketship ? ROCKETSHIP_BILLING_EMAIL : ZRN_BILLING_EMAIL}`}>
                            {isRocketship ? ROCKETSHIP_BILLING_EMAIL : ZRN_BILLING_EMAIL}
                        </a>
                    </Text>
                    <hr />
                </React.Fragment>
            )}
            <Spacer marginBottom="xs">
                <Text fontType="h5" as="div">Pay by Bank Transfer</Text>
            </Spacer>
            <Text as="div" fontType="bodySmallHeading">Bank Name: Silicon Valley Bank</Text>
            <Text as="div" fontType="bodySmallHeading">Account Name: Zillow, Inc.</Text>
            <Text as="div" fontType="bodySmallHeading">ABA / Routing Number: 121140399</Text>
            <Text as="div" fontType="bodySmallHeading">Account Number: 3300755994</Text>
            <hr />
            <Text fontType="h5">Pay by Check</Text>
            <Spacer marginY="xs">
                <Text>
                    Please include the invoice number in your check remittance
                    and mail your payment to the following address:
                </Text>
            </Spacer>
            <Text as="div" fontType="bodySmallHeading">Zillow, Inc,</Text>
            <Text as="div" fontType="bodySmallHeading">Dept. 3267</Text>
            <Text as="div" fontType="bodySmallHeading">PO Box 123267</Text>
            <Text as="div" fontType="bodySmallHeading">Dallas, TX 75312-3267</Text>
            <Spacer marginY="xs">
                <img src={CheckSampleImage} alt="Sample Check" />
            </Spacer>
            <Text>{BillingConstants.BILLING_INFO_FOOTNOTE}</Text>
        </Spacer>
    );
};

export default PaymentInfoModal;
